import { SVGProps, Ref, forwardRef } from 'react';

export const FrameStarFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m9.342 9.342-.74.309C6.202 10.65 5 11.15 5 12c0 .848 1.201 1.348 3.603 2.349l.74.308.308.74C10.65 17.798 11.15 19 12 19c.848 0 1.348-1.2 2.349-3.603l.308-.739.74-.308C17.798 13.35 19 12.849 19 12c0-.848-1.2-1.349-3.603-2.35l-.739-.307-.308-.74C13.35 6.2 12.849 5 12 5c-.848 0-1.349 1.201-2.35 3.603z"
                fill="currentColor"
            />
            <path
                d="M2.809 16.05c.05.543.112 1.03.195 1.468.246 1.306.617 2 1.048 2.431.43.43 1.125.802 2.431 1.048.438.083.925.145 1.468.195V23C3.005 22.577 1.423 20.995 1 16.05z"
                fill="currentColor"
            />
            <path
                d="M23 16.05c-.422 4.945-2.005 6.527-6.95 6.95v-1.808q.813-.073 1.468-.195c1.306-.246 2-.617 2.431-1.048.431-.43.802-1.125 1.048-2.431q.122-.655.195-1.468z"
                fill="currentColor"
            />
            <path
                d="M16.05 1c4.946.423 6.528 2.006 6.95 6.952h-1.808c-.05-.543-.112-1.03-.195-1.468-.246-1.306-.617-2-1.048-2.431-.43-.43-1.125-.802-2.431-1.048a16 16 0 0 0-1.468-.196z"
                fill="currentColor"
            />
            <path
                d="M7.951 2.809q-.813.073-1.468.196c-1.306.246-2 .617-2.431 1.048-.431.43-.802 1.125-1.048 2.431-.083.438-.145.925-.195 1.468H1C1.423 3.006 3.005 1.422 7.951 1z"
                fill="currentColor"
            />
        </g>
    </svg>
));
FrameStarFilledSize24Glyph.displayName = 'FrameStarFilledSize24Glyph';
